import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=fe2df518&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=fe2df518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2df518",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe2df518')) {
      api.createRecord('fe2df518', component.options)
    } else {
      api.reload('fe2df518', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=fe2df518&scoped=true&", function () {
      api.rerender('fe2df518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NCam07jyV3U3/JS/comp/DocBox.vue"
export default component.exports